import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {css} from 'aphrodite';
import {
  Col,
  Button,
  FormControl,
  FormGroup,
  InputGroup,
  Modal,
  OverlayTrigger,
  Tooltip,
} from 'react-bootstrap';

import {nodeId} from 'libs/utils';

import './styles.scss';


/**
 * ToolTipCell is used to display a tooltip when hoving the mouse over the `placeholder`.
 *
 * props parameters:
 * @param {object|string} placeholder html fragment or text to hover over to display tooltip.
 * @param {string}        text        text to display in the tooltip.
 * @param {string}        id          id property for the tooltip.
 * @param {string}        placement   where to place the tooltip, 'top', 'bottom', 'right' or 'left'.
 * @param {object}        styleSheet  (Optional) If provided, must contain tooltip attribute, which contains the css for the tooltip.
 *
 * @returns ToolTipCell component
 */
export class ToolTipCell extends Component {
  render() {
    const {
      placeholder,
      text,
      id,
      placement,
      styleSheet,
    } = this.props;

    if (!text) {
      return (<span>{placeholder}</span>);
    }

    let tooltip = <Tooltip id={id} className={styleSheet ? css(styleSheet.tooltip) : ''}>{text}</Tooltip>;

    return (
      <OverlayTrigger
        overlay={tooltip}
        placement={placement}
        delayShow={150}
        delayHide={150}
      >
        <span>{placeholder}</span>
      </OverlayTrigger>
    );
  }
}

ToolTipCell.propTypes = {
  id: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  placeholder: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]),
  text: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]),
  placement: PropTypes.oneOfType([
    PropTypes.string,
  ]),
  styleSheet: PropTypes.object,
};

ToolTipCell.defaultProps = {
  placement: 'top',
};

export const EditableCell = ({value, onValue, id}) => {
  const parseValue = (v) => (value === parseFloat(value) ? parseFloat(v) : v);

  const onKeyUp = (e) => {
    input = parseValue(e.target.value);

    if (e.key === 'Enter') {
      onValue(input);
    }

    if (e.key === 'Escape') {
      onValue();
    }
  };

  let input = parseValue(value);

  return (
    <FormGroup controlId={id || nodeId('editable-cell')} data-component={'EditableCell'}>
      <InputGroup>
        <FormControl
          type={'text'}
          defaultValue={value}
          onKeyUp={onKeyUp}
          onBlur={() => onValue()}
          autoFocus
        />
        <InputGroup.Button>
          <Button
            bsStyle={'success'}
            onMouseDown={() => onValue(input)} >
            <i className={'fa fa-check'}></i>
          </Button>
        </InputGroup.Button>
      </InputGroup>
    </FormGroup>
  );
};

EditableCell.propTypes = {
  value: PropTypes.any,
  id: PropTypes.string,
  onValue: PropTypes.func,
};


export class ModalCell extends Component {
  constructor() {
    super();

    this.state = {
      showModal: false,
    };

    this._toggleModal = this._toggleModal.bind(this);
  }

  _toggleModal() {
    this.setState({showModal: !this.state.showModal});
  }

  render() {
    const {
      children,
      modalHeader,
      modalContent,
    } = this.props;

    return (
      <div data-component={'ModalCell'}>
        <a onClick={this._toggleModal}>{children}</a>
        <Modal show={this.state.showModal} onHide={this._toggleModal}>
          <Modal.Header>
            <Col sm={12}>
              <Button className={'pull-right btn-link'} onClick={this._toggleModal}><i className={'fa fa-times fa-2x pull-right text-danger cursor--hover-pointer'}></i></Button>
              {modalHeader}
            </Col>
          </Modal.Header>
          <Modal.Body>
            <Col sm={12}>
              {modalContent}
            </Col>
            <div className={'clearfix'}></div>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}

ModalCell.propTypes = {
  children: PropTypes.node.isRequired,
  modalContent: PropTypes.string.isRequired,
  modalHeader: PropTypes.element,
};
